import { Skeleton } from 'antd';
import React from 'react';

const CodeSkeleton = () => {
  return (
    <div style={{ 
      padding: '24px',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      borderRadius: 4
    }}>
      {/* Code header skeleton */}
      <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
        <Skeleton.Button active style={{ width: 100, height: 24 }} />
        <Skeleton.Button active style={{ width: 80, height: 24 }} />
      </div>
      
      {/* Code lines skeleton - mimics code structure */}
      <div style={{ 
        fontFamily: 'monospace',
        display: 'flex',
        flexDirection: 'column',
        gap: 4
      }}>
        <Skeleton.Input active style={{ width: '60%', height: 20 }} />
        <Skeleton.Input active style={{ width: '80%', height: 20 }} />
        <Skeleton.Input active style={{ width: '45%', height: 20 }} />
        <Skeleton.Input active style={{ width: '70%', height: 20 }} />
        <Skeleton.Input active style={{ width: '55%', height: 20 }} />
        <Skeleton.Input active style={{ width: '85%', height: 20 }} />
        <Skeleton.Input active style={{ width: '40%', height: 20 }} />
        <Skeleton.Input active style={{ width: '75%', height: 20 }} />
        <Skeleton.Input active style={{ width: '50%', height: 20 }} />
        <Skeleton.Input active style={{ width: '65%', height: 20 }} />
        <Skeleton.Input active style={{ width: '90%', height: 20 }} />
        <Skeleton.Input active style={{ width: '35%', height: 20 }} />
      </div>
    </div>
  );
};

export default CodeSkeleton;
